module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-142542893-1"],"pluginConfig":{"head":false,"respectDNT":true,"exclude":["/blog/preview**"]}},
    }]
